import React, {useEffect, useRef, useState} from 'react';
import {Button, Form, Modal, Select} from 'antd';
import {useDispatch} from 'react-redux';
import {handleOrder} from "../../store/SettingRedux/SettingRedux";
import Pallet from "../../http_request/Model/pallet/Pallet";

const QcModal = () => {
    const [form] = Form.useForm();

    const [open, setOpen] = useState(false);
    const [orderNumberListLoading, setOrderNumberListLoading] = useState(false);
    const [orderNumberList, setOrderNumberList] = useState([]);
    const dispatch = useDispatch();
    const inputRef = useRef(null);

    const handleShow = () => {

        setOpen(true);

    };
    useEffect(() => {

        inputRef?.current?.focus({
            cursor: 'start',
        });

    }, [open]);

    const handleCancel = () => {
        setOpen(false);
    };
    const onFinish = (values) => {
        handleCancel()

        dispatch(handleOrder(values))
    }


    useEffect(() => {
        if (open) {

            Pallet.request({
                beforeSend: () => {
                    setOrderNumberListLoading(true)
                }, success: (res) => {
                    setOrderNumberList(res)


                }, error: (error) => {

                }, final: () => {
                    setOrderNumberListLoading(false)
                },
            }).orderList();
        }
    }, [open]);
    return (<>
            <div>
                <Button className='defBtn blueBtn' onClick={handleShow}>حواله</Button>

                <Modal
                    open={open}
                    title='ثبت در حواله'
                    onOk={onFinish}
                    onCancel={handleCancel}
                    footer={[<Button className='defBtn redBtn' key='back' onClick={handleCancel}>
                        انصراف
                    </Button>, <Button className='defBtn blueBtn' key='submit' type='primary'
                                       onClick={() => {
                                           form.submit()
                                       }}>
                        ثبت
                    </Button>,

                    ]}
                >

                    <Form
                        name="basic" form={form}
                        layout='vertical'
                        onFinish={onFinish}
                        autoComplete="off"
                    >
                        <Form.Item
                            name="orderNumber"
                            label="شماره حواله"
                            rules={[{
                                required: true, message: 'لطفا شماره حواله را وارد کنید!',
                            },]}

                        >


                            <Select showSearch
                                    filterOption={(input, option) => {
                                        return (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())
                                    }}


                                    loading={orderNumberListLoading}
                                    options={orderNumberList}/>


                        </Form.Item>


                    </Form>


                </Modal>
            </div>
        </>

    );
};
export default QcModal;